import { alertEnum } from '@/enums/AlertEnum'
type AlertType = (typeof alertEnum)[keyof typeof alertEnum]

export interface AlertItem {
  label: string
  count: number
}

export interface AlertOptions {
  title?: string
  items?: AlertItem[]
}

class Alert {
  constructor(
    public message: string,
    public type: AlertType,
    public options?: AlertOptions,
  ) {}
}

export default Alert
